// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2qB_y","col":"styles_col__2ut6a"};